import { createSelector } from "@reduxjs/toolkit";

export const getEnergyAssistance = (state) => state.energyAssistance;

export const getProfileInfo = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.profileInfo
);

export const getCurrentBilling = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.currentBilling
);

export const getEnergyUsage = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.energyUsage
);

export const getAccountLookup = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.accountLookup
);

export const getGrantInfo = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.grantInfo
);

export const getReportAccountBalance = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.accountBalanceReport
);

export const getBillPaymentHistory = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.billingAndPaymentHistory
);

export const getReportEnergyUsage = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.energyUsageReport
);

export const getBillPaymentPDF = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.billPaymentPDF
);

export const getCurrentBillPDF = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.currentBillPDF
);

export const getManageSeason = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.manageSeason
);

export const getEmergencyHold = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.emergencyHold
);

export const getEmergencyHoldStatus = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.emergencyHoldStatus
);

export const getReportSampleFile = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.reportSampleFile
);

export const getAgencyList = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.agencies
);

export const getOutstandingGrantReports = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.grantReport
);

export const getTooltipMsgs = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.tooltipMsgs
);

export const getReconnectionRequestReport = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.reconnectionRequestReport
);

export const getPledgeAmountReport = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.pledgeAmountReport
);

export const getEmergencyHoldReport = createSelector(
  [getEnergyAssistance],
  (energyAssistance) => energyAssistance.emergencyHoldReport
);
